import { itemdimensionanalysisConstant } from '../constants';
import { itemdimensionanalysisService } from '../services';

export const itemdimensionanalysisAction = {
    fetchItemDetails,
    fetchItemSummary,
    resetItemDetails,
};

function fetchItemDetails(itemId) {
    return (dispatch) => {
      dispatch(getRequest());
      itemdimensionanalysisService.fetchItemDetails(itemId).then(
        (item) => {
          dispatch(getSuccess(item));
        },
        (error) => {
          dispatch(getFailure(error));
        }
      );
    };
    function getRequest() {
      return { type: itemdimensionanalysisConstant.GET_ITEM_DETAILS_REQUEST };
    }
    function getSuccess(item) {
      return {
        type: itemdimensionanalysisConstant.GET_ITEM_DETAILS_SUCCESS,
        item,
      };
    }
    function getFailure(error) {
      return { type: itemdimensionanalysisConstant.GET_ITEM_DETAILS_FAILURE, error };
    }
}

function fetchItemSummary(itemId) {
  return (dispatch) => {
    dispatch(getRequest());
    itemdimensionanalysisService.fetchItemSummary(itemId).then(
      (item) => {
        dispatch(getSuccess(item));
      },
      (error) => {
        dispatch(getFailure(error));
      }
    );
  };
  function getRequest() {
    return { type: itemdimensionanalysisConstant.GET_ITEM_SUMMARY_REQUEST };
  }
  function getSuccess(item) {
    return {
      type: itemdimensionanalysisConstant.GET_ITEM_SUMMARY_SUCCESS,
      item,
    };
  }
  function getFailure(error) {
    return { type: itemdimensionanalysisConstant.GET_ITEM_SUMMARY_FAILURE, error };
  }
}

function resetItemDetails() {
    return { type: itemdimensionanalysisConstant.RESET_ITEM_DETAILS };
}